// extracted by mini-css-extract-plugin
export default {"colorBlue":"#007faf","maxMobile":"(max-width: 668px)","jobSummary":"JobList_jobSummary__6a08c","jobTitle":"JobList_jobTitle__GgoAM typography_bold__VUNXF"};